// extracted by mini-css-extract-plugin
module.exports = {"Item":"Legend_Item__BV6OP","Fill":"Legend_Fill__SD+qT","Label":"Legend_Label__SbStD"};